import coreLogger from '@adc/logger'
import {
  NOTIFICATION_MESSAGES,
  NotificationMessageKey,
  NotificationMessage,
} from './messages/index'

const logger = coreLogger.forModule('AUCTIONCOM')

interface MediumNotifier {
  // Medium notifiers (overlay/toast/snackbar/pageBanner) each accept their own
  // option shape; the named layer only forwards the resolved options through.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  open: (options: any) => void
}

interface MediumNotifierMap {
  overlayBanner: MediumNotifier
  toast: MediumNotifier
  snackbar: MediumNotifier
  pageBanner: MediumNotifier
}

class NamedNotifier {
  private _notifiers: MediumNotifierMap

  constructor(notifiers: MediumNotifierMap) {
    this._notifiers = notifiers
  }

  fire(key: string, ctx?: Record<string, unknown>): void {
    const messageFactory = NOTIFICATION_MESSAGES[
      key as NotificationMessageKey
    ] as ((ctx?: Record<string, unknown>) => NotificationMessage) | undefined

    if (!messageFactory) {
      logger.warn(
        `Unknown notification message key: "${key}". No notification will be shown.`
      )
      return
    }

    const { medium, ...options } = messageFactory(ctx)
    const notifier = this._notifiers[medium]

    if (notifier) {
      notifier.open(options)
    } else {
      logger.warn(
        `No notifier registered for medium "${medium}". Cannot show notification for key "${key}".`
      )
    }
  }
}

export { NamedNotifier }
export type { MediumNotifierMap }
